// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__Z23dx","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3R9qD"};